<div *ngIf="_state === _value" [ngClass]="_cls">X</div>
<button
  *ngIf="_state !== _value"
  (click)="checked()"
  class="report-button"
></button>
